export const CHANGE_PASSWORD = 'components/change-password/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_RESPONSE ='components/change-password/CHANGE_PASSWORD_RESPONSE';

export const changePassword = (data) => {
    return {
        type: CHANGE_PASSWORD,
        data
    }
}
export const changePasswordResponse = (data) => {
    return {
        type: CHANGE_PASSWORD_RESPONSE,
        data
    }
}

export const VALIDATING_JWT_TOKEN = 'components/change-password/VALIDATING_JWT_TOKEN';
export const VALIDATING_JWT_TOKEN_SUCCESS ='components/change-password/VALIDATING_JWT_TOKEN_SUCCESS';
export const VALIDATING_JWT_TOKEN_FAILURE = 'components/change-password/VALIDATING_JWT_TOKEN_FAILURE';

export const validateJwtToken = (data) => {
    return {
        type: VALIDATING_JWT_TOKEN,
        data
    }
}
export const validateJwtTokenSuccess = (data) => {
    return {
        type: VALIDATING_JWT_TOKEN_SUCCESS,
        data
    }
}
export const validateJwtTokenFailure = (err) => {
    return {
        type: VALIDATING_JWT_TOKEN_FAILURE,
        err
    }
}
